export default __webpack_public_path__ + "static/media/white_horizontal_menu.988120ab.svg";